var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Section, Button, Heading } from '../../shared';
import { services } from '../../../shared';
import { CASE } from '../../../config/routes';
import { CustomerDocumentsTable } from '../../sections/documents/customer-documents/customer-documents';
import { SectionMenu } from '../../../components/sections/question-sets/section-menu/section-menu';
import { UploadDocument } from '../../sections/upload-document/upload-document';
export var DocumentsPage = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var location = _a.location;
    var _k = useParams(), caseId = _k.caseId, loanPurposeId = _k.loanPurposeId;
    var _l = useState([]), pages = _l[0], setPages = _l[1];
    var _m = useState(), caseDetails = _m[0], setCaseDetails = _m[1];
    var _o = useState(), modalVisible = _o[0], setModalVisible = _o[1];
    var _p = useState(0), customerIdForUpload = _p[0], setCustomerIdForUpload = _p[1];
    var _q = useState(0), documentGridToRefresh = _q[0], setDocumentGridToRefresh = _q[1];
    var _r = useState([]), documentCounts = _r[0], setDocumentCounts = _r[1];
    var _s = useState(true), mandatoryDocuments = _s[0], setMandatoryDocuments = _s[1];
    var _t = useState(false), allowProceed = _t[0], setAllowProceed = _t[1];
    var _u = useState(false), toggleMenuVisibility = _u[1];
    var _v = useState(0), refreshedCounter = _v[0], setRefreshedCounter = _v[1];
    var fetchPageWithStatus = function (caseId, formId) { return __awaiter(void 0, void 0, void 0, function () {
        var pageWithStatus;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getPagesWithStatus(caseId, formId)];
                case 1:
                    pageWithStatus = (_a.sent()).data;
                    setPages(pageWithStatus);
                    return [2 /*return*/, pageWithStatus[0].sections[0].id];
            }
        });
    }); };
    var fetchDocuments = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var documents, applicant, docCounts, sum;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getCustomerDocuments(id)];
                case 1:
                    documents = (_a.sent()).data;
                    applicant = caseDetails.applicants.filter(function (a) { return a.customerId === id; })[0];
                    docCounts = documentCounts;
                    docCounts.splice(caseDetails.applicants.indexOf(applicant), 1, documents.length);
                    setDocumentCounts(docCounts);
                    sum = docCounts.reduce(function (sum, a) { return sum + a; });
                    setAllowProceed(sum > 0);
                    return [2 /*return*/, documents];
            }
        });
    }); };
    var showModal = function (e) {
        setCustomerIdForUpload(Number(e.currentTarget.getAttribute('data-value')));
        setModalVisible(true);
    };
    var reloadDocumentGrid = function (customerId) {
        setDocumentGridToRefresh(customerId);
    };
    var hideModal = function () {
        setModalVisible(false);
    };
    var fetchCaseDetails = function (id, loanPurposeId) { return __awaiter(void 0, void 0, void 0, function () {
        var caseDetail, _a, mandatoryDocs;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!((_b = location.state.case) !== null && _b !== void 0)) return [3 /*break*/, 1];
                    _a = _b;
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, services.getCase(id)];
                case 2:
                    _a = (_c.sent()).data;
                    _c.label = 3;
                case 3:
                    caseDetail = _a;
                    location.state = {
                        applicants: caseDetail.applicants,
                        case: caseDetail,
                        loanPurposeId: loanPurposeId,
                    };
                    setDocumentCounts(caseDetail.applicants.map(function () { return 0; }));
                    return [4 /*yield*/, services.getMandatoryDocuments()];
                case 4:
                    mandatoryDocs = (_c.sent()).data;
                    setMandatoryDocuments(mandatoryDocs.value.toLowerCase() === 'on');
                    setCaseDetails(caseDetail);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var id, loanPurpose;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    id = Number(caseId);
                    loanPurpose = Number(loanPurposeId);
                    //await fetchPageWithStatus(id, applicationProgressBarSteps.formId);
                    return [4 /*yield*/, fetchCaseDetails(id, loanPurpose)];
                case 1:
                    //await fetchPageWithStatus(id, applicationProgressBarSteps.formId);
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var _a;
        location.state = (_a = location.state) !== null && _a !== void 0 ? _a : {
            applicants: [],
            case: null,
            loanPurposeId: Number(loanPurposeId),
        };
        fetchData();
    }, [caseId]);
    var deleteDocument = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var id;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!window.confirm('Are you sure you wish to delete this document?')) return [3 /*break*/, 2];
                    id = e.currentTarget.getAttribute('data-value');
                    return [4 /*yield*/, services.deleteCustomerDocument(Number(id))];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        setRefreshedCounter(refreshedCounter + 1);
    }, [documentGridToRefresh, customerIdForUpload]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Section, null,
            React.createElement(UploadDocument, { customerId: customerIdForUpload, reloadDocumentGrid: function (customerId) {
                    setRefreshedCounter(refreshedCounter + 1);
                    reloadDocumentGrid(customerId);
                }, show: modalVisible, handleClose: hideModal, isEmailSend: false }),
            React.createElement("div", { className: "l-grid" },
                React.createElement("div", { className: "l-grid_span-12 l-grid_span-4@bp20" },
                    React.createElement(SectionMenu, { pages: pages, rootPath: "".concat(CASE.paths[0], "/").concat((_d = (_c = (_b = location === null || location === void 0 ? void 0 : location.state) === null || _b === void 0 ? void 0 : _b.case) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : caseId, "/"), location: location, workflowName: "documents", closeMenu: toggleMenuVisibility })),
                React.createElement("div", { className: "l-grid_span-12 l-grid_span-8@bp20" },
                    React.createElement(Heading, { level: "h3", title: 'Documents Required', mb: 4 }),
                    React.createElement("span", { className: "u-fs-2" }, "Please upload supporting documentation:"),
                    ((_e = caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.applicants) === null || _e === void 0 ? void 0 : _e.length) > 0 &&
                        ((_g = (_f = caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.applicants) === null || _f === void 0 ? void 0 : _f.filter(function (a) { var _a; return (_a = a.isMainApplicant) !== null && _a !== void 0 ? _a : false; })) === null || _g === void 0 ? void 0 : _g.length) > 0 && (React.createElement(CustomerDocumentsTable, { applicant: (_h = caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.applicants) === null || _h === void 0 ? void 0 : _h.filter(function (a) { var _a; return (_a = a.isMainApplicant) !== null && _a !== void 0 ? _a : false; })[0], deleteDocumentFunction: deleteDocument, fetchData: fetchDocuments, showModal: showModal, modalVisible: modalVisible, refresh: refreshedCounter })), (_j = caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.applicants) === null || _j === void 0 ? void 0 :
                    _j.filter(function (a) { return !a.isMainApplicant; }).map(function (doc, index) {
                        var _a;
                        return (React.createElement("div", { key: doc.customerId },
                            React.createElement("span", null),
                            React.createElement(CustomerDocumentsTable, { key: doc.customerId, applicant: (_a = caseDetails === null || caseDetails === void 0 ? void 0 : caseDetails.applicants) === null || _a === void 0 ? void 0 : _a.filter(function (a) { return a.customerId === doc.customerId; })[0], index: index + 1, deleteDocumentFunction: deleteDocument, fetchData: fetchDocuments, showModal: showModal, modalVisible: modalVisible, refresh: refreshedCounter })));
                    }),
                    React.createElement("div", null,
                        React.createElement(Button, { variant: "primary", childClasses: "continue-button", type: "button", disabled: (mandatoryDocuments && allowProceed) || !mandatoryDocuments ? false : true }, pages.indexOf(pages.filter(function (p) { return p.name === 'Documents'; })[0]) === pages.length - 1
                            ? 'Complete Full Mortgage Application'
                            : 'Continue')))))));
};
